import { Button } from '@/components/ui/button';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from './AuthContext';
import SEO from '@/components/SEO';

export default function Unauthorized() {
  const { user, signOut } = useAuth();
  return (
    <>
      <SEO title="CRM Pro — En attente d'autorisation" description="Espace privé." noindex />
      <div className="min-h-screen flex items-center justify-center px-4 bg-slate-950">
        <div className="w-full max-w-md bg-slate-900 border border-slate-800 rounded-2xl p-8 shadow-lg text-center space-y-5">
          <div className="w-12 h-12 mx-auto rounded-full bg-amber-500/10 flex items-center justify-center">
            <ShieldAlert className="text-amber-400" size={24} strokeWidth={1.5} />
          </div>
          <h1 className="text-xl font-serif text-slate-100">Compte en attente d'autorisation</h1>
          <p className="text-sm text-slate-400">
            Bonjour <span className="text-slate-200">{user?.email}</span>,<br />
            votre compte a bien été créé. Un administrateur doit maintenant vous attribuer un rôle pour accéder au CRM.
          </p>
          <p className="text-xs text-slate-500">
            Contactez Cyrille (CYGNATURE PRODUCTION) pour activer votre accès.
          </p>
          <Button onClick={signOut} variant="outline" className="w-full bg-slate-950 border-slate-800 text-slate-100 hover:bg-slate-800">
            Se déconnecter
          </Button>
        </div>
      </div>
    </>
  );
}
